// Rewards support experience config. Rewards is an AI-only surface: unlike teamsExperience.ts (the
// Model-A template it was cloned from) it carries no live-agent/Omnichannel copy, because the page
// has no handoff path — an unresolved issue creates a support case instead.
// Layout + copy + assets match the approved rewards mock (derived from the live rewards.bing.com/about
// page); the official illustrations are self-hosted under public/rewards-assets/.
export const rewardsExperience = {
  routeHash: '#/rewards',
  entryPoint: 'rewards',
  headerButtonLabel: 'Rewards',
  headerButtonAriaLabel: 'Open Microsoft Rewards support chat in a new tab',
  brandName: 'Microsoft Rewards',
  brandLogo: '/rewards-assets/logo-light.png',
  // Real destinations on the live site (verified redirects): Dashboard/Earn/Redeem/About are top-level
  // routes; Status and Winners are dashboard modals (rewards.bing.com/status and /winners both 30x
  // redirect to these dashboard?modal= URLs), so they point straight at the modal deep link.
  navItems: [
    { label: 'Dashboard', href: 'https://rewards.bing.com/' },
    { label: 'Earn', href: 'https://rewards.bing.com/earn' },
    { label: 'Redeem', href: 'https://rewards.bing.com/redeem' },
    { label: 'About', href: 'https://rewards.bing.com/about' },
    { label: 'Status', href: 'https://rewards.bing.com/dashboard?modal=membership' },
    { label: 'Winners', href: 'https://rewards.bing.com/dashboard?modal=winners' },
  ],
  navActive: 'About',
  pageTitle: 'Microsoft Rewards Support',
  pageEyebrow: 'Microsoft Rewards',
  pageHeadline: 'Hi there, Welcome to Microsoft Rewards Support',
  pageSubtitle:
    'Get help earning, redeeming, and making the most of your Microsoft Rewards points.',
  signInCtaLabel: 'Sign in to ask the MS Rewards Assistant',
  heroImage: '/rewards-assets/about-header-light.png',
  agentName: 'Microsoft Rewards Assistant',
  panelTitle: 'Microsoft Rewards Assistant',
  welcomeMessage:
    'Hi, I can help with Microsoft Rewards. Ask me about redeeming, earning, or fast points strategies.',
  errorPrefix: 'Sorry, something went wrong.',
  heroInputPlaceholder: 'Ask the Microsoft Rewards Assistant',
  heroAskLabel: 'Ask',
  panelInputPlaceholder: 'Type a reply',
  askPlaceholder: 'Ask your question',
  sendButtonLabel: 'Send',
  userName: 'You',
  userAvatar: 'Y',
  agentAvatar: 'MR',
  logoText: 'R',
  quickPrompts: [
    'How do I redeem my points',
    'How do I earn points',
    'what are fast points strategies',
  ],
  sectionTitle: 'Three ways Microsoft Rewards helps',
  sectionIntro:
    'A support-first version of the Rewards page, preserving the same visual rhythm and familiar pillar layout.',
  pillars: [
    {
      title: 'Start earning points',
      desc: 'Find the activities, searches, and everyday Microsoft experiences that help build your points balance.',
      image: '/rewards-assets/start-earning-points.jpg',
    },
    {
      title: 'Earn with Microsoft',
      desc: 'Learn how Bing, Edge, Xbox, and Microsoft Store activity can contribute to your Rewards progress.',
      image: '/rewards-assets/earn-with-microsoft.jpg',
    },
    {
      title: 'Reward yourself',
      desc: 'Understand gift cards, donations, sweepstakes, and other ways to redeem the points you have earned.',
      image: '/rewards-assets/reward-yourself.jpg',
    },
  ],
  productsTitle: 'Earn across Microsoft',
  productsIntro:
    'Rewards support can guide you through the services where points are earned and redeemed.',
  products: [
    { name: 'Bing', image: '/rewards-assets/product-bing.svg' },
    { name: 'Xbox', image: '/rewards-assets/product-xbox.svg' },
    { name: 'Microsoft Edge', image: '/rewards-assets/product-edge.svg' },
    { name: 'Microsoft', image: '/rewards-assets/product-microsoft.svg' },
  ],
  theme: {
    accent: '#0078d4',
    accentHover: '#106ebe',
    accentSoft: 'rgba(0, 120, 212, 0.08)',
    accentFg: '#ffffff',
    pageBackground: '#f7f4ef',
    pageBackgroundElevated: '#fcfbf8',
    surface: '#ffffff',
    surfaceSoft: '#f5f5f5',
    text: '#242424',
    textMuted: '#5c5c5c',
    textSoft: '#6f6f6f',
    link: '#0067b8',
    border: '#dedede',
    borderStrong: '#919191',
    systemBackground: '#f5f5f5',
    systemBorder: '#dedede',
    shadow: '0 18px 48px rgba(0, 0, 0, 0.12)',
  },
};
